
import React from 'react';
import { Input } from '@/components/ui/input';

interface FinanceProcurementsSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const FinanceProcurementsSearch: React.FC<FinanceProcurementsSearchProps> = ({ 
  searchTerm, 
  setSearchTerm 
}) => {
  return (
    <div className="mb-6">
      <Input
        placeholder="Search by product name, source type, or ID..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="max-w-sm"
      />
    </div>
  );
};

export default FinanceProcurementsSearch;
